
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { EventBusService } from 'src/app/admihair/shared/event-bus.service';
import { Subscription } from 'rxjs';
import { Table } from 'primeng/table';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AdministradoraService } from '../../service/administradora.service';
import { Administradora } from '../../api/dto/administradora';
import { PermissaoService } from '../../service/permissao.service';
import { Permissao } from '../../api/dto/permissao';

@Component({
  selector: 'app-selecionar-franquia',
  templateUrl: './selecionar-franquia.component.html',
  styleUrls: ['./selecionar-franquia.component.scss']
})
export class SelecionarFranquiaComponent {

  constructor(private administradoraService: AdministradoraService,
    private permissaoService: PermissaoService,
    private utilStorageService: UtilStorageService,
    private eventBusService: EventBusService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private layoutService: LayoutService) { }

  isLoggedIn = false;
  acesso?: any;
  eventBusSub?: Subscription;
  administradoras: Administradora[] = [];
  loading: boolean = false;
  loadingFranquias: boolean = false;

  @ViewChild('filter') filter!: ElementRef;
  ngOnInit(): void {
    this.loadingFranquias = true;
    this.layoutService.state.profileSidebarVisible = false;
    this.isLoggedIn = !!this.utilStorageService.getToken();

    if (this.isLoggedIn) {
      this.acesso = this.utilStorageService.getUser();
    }

    this.eventBusSub = this.eventBusService.on('logout', () => {
      this.logout();
    });
    this.listarAdministradorasPorUsuario(this.acesso.usuario.id);

    
  }

  listarAdministradorasPorUsuario(usuarioId: number) {
    this.administradoraService.listarAdminstradorasPorUsuarioId(usuarioId).subscribe({
      next: (data: Administradora[]) => {
        this.loadingFranquias = false;
        if(data.length > 1){
          this.administradoras = data;
        }
        if(data.length === 1){
          this.selecionarAdministradora(data[0]);
        }
        if(data.length === 0){
          this._router.navigate(["/auth/access-yet"], { relativeTo: this._activatedRoute });
        }
      },
      error: (err: any) => {
        this.loadingFranquias = false;
        console.log('erro:', err);
      }
    });
  }

  selecionarAdministradora(administradora: Administradora) {
    this.loadingFranquias = true;
    this.listarPermissoesUsuario(this.acesso.usuario.id, administradora);
  }

  listarPermissoesUsuario(usuarioId?: number, administradora?: Administradora) {
      if (administradora) {
        this.permissaoService.listarPorAdministradoraEUsuario(administradora.id, usuarioId).subscribe({
          next: (data: String[]) => {
            this.utilStorageService.saveAdministradora(administradora);
            this.utilStorageService.savePermissoes(data);
            this._router.navigate(["/rfarias/dashboard"], { relativeTo: this._activatedRoute });
          },
          error: (err: any) => {
  
          }
        })
      }
  
    }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  logout(): void {
    this.utilStorageService.signOut();

    this.isLoggedIn = false;
    this.navigateToFirstChild();
  }

  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  redirecionarSemVinculoEmpresa(){
    this._router.navigate(["/auth/access-yet"], { relativeTo: this._activatedRoute })
  }

  get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'dark';
	}

}
